import { dashboardsByRole } from "dashboard/constants";
import { DashboardRole } from "dashboard/models";
import { useBoundStore } from "store";

export const DashboardSelector = () => {
  const { user } = useBoundStore();
  const role: DashboardRole = (user?.role as DashboardRole) ?? "basic";
  const Dashboard = dashboardsByRole[role] ?? dashboardsByRole["basic"];
  return <Dashboard />;
};
